import { render, staticRenderFns } from "./ConsumptionDevicesDetailsPage.vue?vue&type=template&id=36f178ec&scoped=true"
import script from "./ConsumptionDevicesDetailsPage.vue?vue&type=script&lang=js"
export * from "./ConsumptionDevicesDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionDevicesDetailsPage.vue?vue&type=style&index=0&id=36f178ec&prod&scoped=true&lang=scss"
import style1 from "./ConsumptionDevicesDetailsPage.vue?vue&type=style&index=1&id=36f178ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f178ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VProgressCircular})
